import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import "../../../UserDashboard/components/UserDashboardHome/UserDashboardHome.css";
import localeText from "../../../../locale";
import { Toast } from "primereact/toast";
import "../../../UserDashboard/components/StatementTable/StatementTable.css";
import { Column } from "primereact/column";
import { Link } from "react-router-dom";
import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import ProductService from "../../../../service/ProductService";
import { FilterMatchMode } from "primereact/api";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { formatPrice } from "../../../../utilities/formatPrice";

const ListProducts = () => {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);

  const productService = new ProductService();
  const toast = useRef(null);

  const filters2 = {
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "user.username": { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  useEffect(() => {
    let cancel = false;

    async function fetchData() {
      try {
        setLoading(true);
        const res = await productService.getAllProducts();
        if (cancel) return;

        if (res.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });
          if (res.messageCode === 500000) console.log(res);
          setLoading(false);
        } else {
          setProducts(res.result);
          setLoading(false);
        }
      } catch (e) {
        if (e.status === 401 || e.status === 403) {
          localStorage.removeItem("__extraconomy_token");
          localStorage.removeItem("__extraconomy_username");
          window.location.replace("/login");
        }
        setLoading(false);
        console.log(e);
      }
    }

    fetchData();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="card border-1 border-300">
      <Toast ref={toast} />

      <h3 className="my-4">{localeText("products")}</h3>
      <hr />

      <DataTable
        className="mt-4 mb-6 p-datatable-customers"
        value={products}
        paginator
        responsiveLayout="scroll"
        loading={loading}
        dataKey="id"
        filters={filters2}
        filterDisplay="row"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={localeText("showingFirstToLast")}
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
      >
        <Column
          header={localeText("productImage")}
          body={(product) => {
            return (
              <Link to={`/product?id=${product.id}`}>
                <AdvancedImage
                  cldImg={cloudinaryInstance
                    .image(product.imageid1)
                    .resize(fill().width(600).height(600))
                    .format("webp")}
                  height={75}
                  style={{ border: "1px solid #E0E0E0" }}
                  className="border-round product-thumbnail"
                />
              </Link>
            );
          }}
          style={{ width: "10%" }}
        />
        <Column
          field="id"
          header={"ID"}
          style={{ width: "15%" }}
          filter
          filterPlaceholder={localeText("search")}
          filters={filters2}
          filterDisplay="row"
          sortable
        />
        <Column
          field="title"
          header={localeText("title")}
          style={{ width: "25%" }}
          filter
          filterPlaceholder={localeText("searchByTitle")}
          filters={filters2}
          filterDisplay="row"
          sortable
        />
        <Column
          field="user.username"
          header={localeText("seller")}
          style={{ width: "15%" }}
          filter
          filterPlaceholder={localeText("searchBySeller")}
          filters={filters2}
          filterDisplay="row"
          sortable
        />
        <Column
          field="priceUnique"
          sortable
          header={localeText("price")}
          body={(product) => {
            const currentCurrency = product.currency;
            return (
              <span>
                {product.promotionalPriceUnique ? (
                  <p>
                    <span className="font-light">
                      {" "}
                      {currentCurrency} {formatPrice(product.promotionalPriceUnique)}
                      <span
                        className="font-light text-0 p-1 border-round ml-1"
                        style={{ backgroundColor: "#46a748" }}
                      >
                        {"-"}
                        {Math.round(
                          100 - (product.promotionalPriceUnique * 100) / product.priceUnique
                        )}
                        %
                      </span>
                    </span>
                  </p>
                ) : (
                  <p>
                    {currentCurrency} {formatPrice(product.priceUnique)}
                  </p>
                )}
              </span>
            );
          }}
          style={{ width: "15%" }}
        />
        <Column
          header={localeText("productState")}
          body={(product) => {
            return (
              <>
                {product.stateofproduct === "NEW" && <span>{localeText("new")}</span>}
                {product.stateofproduct === "USED" && <span>{localeText("used")}</span>}
              </>
            );
          }}
          style={{ width: "8%" }}
        />
        <Column field="amountInStock" header={localeText("stock")} style={{ width: "8%" }} />
      </DataTable>
    </div>
  );
};

export default ListProducts;
